// extracted by mini-css-extract-plugin
module.exports = {"reliableQuality":"ReliableQuality_reliableQuality__hO2QP","ef-box":"ReliableQuality_ef-box____nU2"};